import { CrudServiceProviderParams, ResultResourceData } from './crud.types';
import useBaseCrudService from './useBaseCrudService';
import useCachedCrudService from './useCachedCrudService';

const useCrudService = <
  TEntity = ResultResourceData,
  TSearchResult = ResultResourceData,
  TSearchAllResult = TEntity[],
  TFindAllResult = TEntity[],
>({
  listResourceUrl,
  singleResourceUrl,
  useService,
  entityName,
}: CrudServiceProviderParams) => {
  return useCachedCrudService<TEntity, TSearchResult, TSearchAllResult, TFindAllResult>(useBaseCrudService, {
    listResourceUrl,
    singleResourceUrl,
    useService,
    entityName,
  });
};

export default useCrudService;
